import { render, staticRenderFns } from "./ConsumptionDetails.vue?vue&type=template&id=4b1b235f&scoped=true"
import script from "./ConsumptionDetails.vue?vue&type=script&lang=ts"
export * from "./ConsumptionDetails.vue?vue&type=script&lang=ts"
import style0 from "./ConsumptionDetails.vue?vue&type=style&index=0&id=4b1b235f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b235f",
  null
  
)

export default component.exports